import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 10l-6-6H2v16h20V10zm-7-4.5l5.5 5.5H15V5.5z"
}), 'NoteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NoteSharp.js
// module id = 5084
// module chunks = 2